import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface RefreshProps {
  primaryColor?: string;
  secondaryColor?: string;
  style?: React.CSSProperties;
}

export const TrashIcon = ({
  primaryColor = RoutalPalette.error.medium,
  secondaryColor = RoutalPalette.white,
  style = {},
  ...props
}: RefreshProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 17" style={{ width: `16px`, height: `17px`, ...style }}>
      <g>
        <path
          d="M12.6668 4.49967V13.833C12.6668 14.1866 12.5264 14.5258 12.2763 14.7758C12.0263 15.0259 11.6871 15.1663 11.3335 15.1663H4.66683C4.31321 15.1663 3.97407 15.0259 3.72402 14.7758C3.47397 14.5258 3.3335 14.1866 3.3335 13.833V4.49967M5.3335 4.49967V3.16634C5.3335 2.81272 5.47397 2.47358 5.72402 2.22353C5.97407 1.97348 6.31321 1.83301 6.66683 1.83301H9.3335C9.68712 1.83301 10.0263 1.97348 10.2763 2.22353C10.5264 2.47358 10.6668 2.81272 10.6668 3.16634V4.49967"
          stroke={primaryColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.6668 4.5V13.8333C12.6668 14.187 12.5264 14.5261 12.2763 14.7761C12.0263 15.0262 11.6871 15.1667 11.3335 15.1667H4.66683C4.31321 15.1667 3.97407 15.0262 3.72402 14.7761C3.47397 14.5261 3.3335 14.187 3.3335 13.8333V4.5"
          fill={primaryColor}
        />
        <path
          d="M2 4.5H3.33333H14"
          stroke={primaryColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.6665 7.83301V11.833"
          stroke={secondaryColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.3335 7.83301V11.833"
          stroke={secondaryColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
};
